<template>
  <div class="top-bar">
    <div class="top-bar_logo-wrapper" @click="onLogoClick">
      <img src="@/assets/imgs/logo.svg" alt="logo" />
    </div>
    <div class="top-bar_product-name">CRM</div>
    <Button
      v-if="shouldShowLogoutBtn"
      type="text"
      class="top-bar_logout"
      @click="reLogin"
    >
      退出登录
      <Icon type="md-log-out" />
    </Button>
  </div>
</template>

<script>
import { Vue, Component } from "vue-property-decorator";
import { Icon, Button } from "view-design";
import { get } from "lodash-es";

@Component({
  name: "TopBar",
  components: {
    Icon,
    Button,
  },
})
export default class TopBar extends Vue {
  get shouldShowLogoutBtn() {
    return this.$route.name !== "login";
  }

  reLogin() {
    localStorage.clear();
    this.$router.push({ name: "login" });
  }

  onLogoClick() {
    if (get(this.$route, ["matched", 0, "name"], "") !== "home") {
      this.$router.push({ name: "home" });
    }
  }
}
</script>

<style lang="scss" scoped>
.top-bar {
  height: 50px;
  display: flex;
  align-items: center;
  padding: 0 20px;
  position: relative;
  flex-shrink: 0;
  // z-index: 2;
  background-color: #fff;

  &_logo-wrapper {
    width: 89px;
    height: 25px;
    margin-bottom: 4px;
    margin-right: 7px;
    cursor: pointer;

    img {
      width: 100%;
      height: 100%;
      display: block;
    }
  }

  &_product-name {
    font-size: 15px;
    background-color: #000;
    color: #fff;
    width: 44px;
    height: 22px;
    text-align: center;
    border-radius: 3px;
    line-height: 22px;
    font-weight: 500;
  }

  &_logout {
    position: absolute;
    right: 4px;
    color: #606060;
    font-size: 14px;

    &:hover {
      color: #e52727;
    }
  }
}
</style>
